/**
 * Converts RGB color values to a hex color string.
 *
 * @param r Red channel (0-255)
 * @param g Green channel (0-255)
 * @param b Blue channel (0-255)
 * @returns A hex color string (e.g., "#a1b2c3")
 */
export const rgbToHex = (r: number, g: number, b: number): string => {
  return `#${[r, g, b].map((c) => c.toString(16).padStart(2, "0")).join("")}`;
};
